<template>
  <n-modal v-bind="$props" :width="500">
    <!-- prettier-ignore -->
    <Form ref="modalForm" :model="model" :label-width="labelWidth" class="n-modal-container" @submit.native.prevent>
      <n-row-col1>
        <!-- companyId -->
        <n-field-selection v-model="model.companyId" field-name="companyId" selection-name="company.company" :error="error.companyId" label="company" disabled/>
      </n-row-col1>
      <n-row-col1>
        <!-- currency -->
        <n-field-selection v-model="model.currency" field-name="currency" selection-name="market.currency" :error="error.currency" label="currency" :disabled="isEdit || disabled" />
      </n-row-col1>
    </Form>
  </n-modal>
</template>
<script>
import NModal from '@/components/common/NModal';
import { add, edit, validate } from '@/api/company/company-currency';

export default NModal.extend({
  name: 'ModalCompanyCurrency',
  components: { NModal },

  methods: {
    doSubmit(model) {
      return this.isEdit ? edit(model) : add(model);
    },

    doValidate(model) {
      return validate(model);
    },
  },
});
</script>
